export * from './skeleton-text.component';
export * from './skeleton-text.module';
